import router from "@/router";
import store from "@/store";

//화면이동에 따른 클래스 정보설정( route의 meta정보이용 ) 처리
export default {
  namespaced: true,
  state: {
    isOpenMenu: false, //햄버그 메뉴 오픈 여부
    navType: "01", //네비게이션 타입 기본 : 01, 메인 : 02, 로고 및 제목 : 03
    navTitle: "", //페이지 제목
    mainClass: "", //메인클래스 정보 p_start, p_main, 기타
    isHeaderLogo: false, //헤더에 로고 표시여부
    isHeaderNoti: false, //헤더에 공지사항 포함여부
    isHeaderSurvey: false, //헤더 만족도 조사 여부
    isHeaderBtn: false, //헤더 타입 03번째 버튼 여부
    isHeaderConBtn: true, //상담사연결 버튼 출력 여부
    isFooterShow: false, //하단 푸터 Display여부
    footerType: "", //하단 통화버튼 01, main 하단 : 02, "" 기본
    footerClass: "", //하단 푸터의 추가 클래스
    isFooterMsgShow: true, //하단 푸터 메시지 출력 여부
    footerBtnName: "", //하단 푸터 버튼 text -03 타입일경우
    footerBtnEnable: false, //하단 푸터 버튼 활성/비활성여부
    footerBtnClicked: "" //하단 버튼 클릭 constants.js 파일에 BTN_KND 항목으로 정의됨.
  },
  mutations: {
    go(state, value) {
      router.push(value);
    },
    setMenuState(state, value) {
      state.isOpenMenu = value;
    },
    toggleMenu(state) {
      state.isOpenMenu = !state.isOpenMenu;
    },
    setNavigationType(state, type) {
      state.navType = type;
    },
    setNavigationTitle(state, title) {
      state.navTitle = title;
    },
    setMainClass(state, mainClass) {
      state.mainClass = mainClass;
    },
    setHeaderLogo(state, isHeaderLogo) {
      state.isHeaderLogo = isHeaderLogo;
    },
    setHeaderNoti(state, isHeaderNoti) {
      state.isHeaderNoti = isHeaderNoti;
    },
    setHeaderSurvey(state, isHeaderSurvey) {
      state.isHeaderSurvey = isHeaderSurvey;
    },
    setHeaderBtn(state, isHeaderBtn) {
      state.isHeaderBtn = isHeaderBtn;
    },
    setHeaderConBtn(state, isHeaderConBtn) {
      state.isHeaderConBtn = isHeaderConBtn;
    },
    setFooterShow(state, isFooterShow) {
      state.isFooterShow = isFooterShow;
    },
    setFooterType(state, type) {
      state.footerType = type;
    },
    setFooterMsgShow(state, isFooterMsgShow) {
      state.isFooterMsgShow = isFooterMsgShow;
    },
    setFooterClass(state, footerClass) {
      state.footerClass = footerClass;
    },
    setFooterBtnName(state, footerBtnName) {
      state.footerBtnName = footerBtnName;
    },
    setFooterBtnEnable(state, isEnable) {
      state.footerBtnEnable = isEnable;
    },
    setFooterBtnClicked(state, btnKind) {
      state.footerBtnClicked = btnKind;
    }
  },
  actions: {
    go({ commit }, payload) {
      //이동 시키는 함수
      commit("go", payload);
    },
    openMenu({ commit }) {
      commit("setMenuState", true);
    },
    closeMenu({ commit }) {
      commit("setMenuState", false);
    },
    toggleMenu({ commit }) {
      commit("toggleMenu");
    },
    setPageUI({ commit }, _route) {
      //네비게이션 헤더 타입 설정

      if (!_route.meta) {
        _route.meta = {};
      }
      const navType = _route.meta.navType ? _route.meta.navType : "00";
      let navTitle = "";
      const mainClass = _route.meta.mclass ? _route.meta.mclass : "";
      const headerLogo =
        _route.meta.hlogo != undefined ? _route.meta.hlogo : true;
      const headerNoti =
        _route.meta.hnotice != undefined ? _route.meta.hnotice : false;
      const headerSurvey =
        _route.meta.hsurvey != undefined ? _route.meta.hsurvey : false;
      const headerBtn =
        _route.meta.hbtn != undefined ? _route.meta.hbtn : false;
      const headerConBtn =
        _route.meta.hconbtn != undefined ? _route.meta.hconbtn : true;
      const footerShow =
        _route.meta.fshow != undefined ? _route.meta.fshow : false;
      const footerType = _route.meta.fType ? _route.meta.fType : "";
      const footerMsgShow =
        _route.meta.fMsg != undefined ? _route.meta.fMsg : true; //출력
      const footerBtnName = _route.meta.fBtnName
        ? _route.meta.fBtnName
        : "확인";
      const footerClass = _route.meta.fclass ? _route.meta.fclass : "";

      //제목설정
      const pgmList = store.getters["system/getPgmData"];
      if (pgmList) {
        const toPgm = pgmList.get(_route.name);
        if (toPgm) {
          navTitle = toPgm.pgm_kor_nm;
        }
      }

      commit("setNavigationType", navType);
      commit("setMainClass", mainClass);
      commit("setHeaderLogo", headerLogo);
      commit("setHeaderNoti", headerNoti);
      commit("setHeaderSurvey", headerSurvey);
      commit("setHeaderBtn", headerBtn);
      commit("setHeaderConBtn", headerConBtn);
      commit("setNavigationTitle", navTitle);
      commit("setFooterShow", footerShow);
      commit("setFooterType", footerType);
      commit("setFooterMsgShow", footerMsgShow);
      commit("setFooterClass", footerClass);
      commit("setFooterBtnName", footerBtnName);
    },
    setNavType({ commit }, _route) {
      //네비게이션 헤더 타입 설정
      const navType = _route.meta.navType;
      commit("setNavigationType", navType);
    },
    setFooterBtnEnable({ commit }, isEnable) {
      commit("setFooterBtnEnable", isEnable);
    },
    setFooterBtnClicked({ commit }, btnKind) {
      commit("setFooterBtnClicked", btnKind);
    }
  },
  getters: {}
};
